import { render, staticRenderFns } from "./DiscountUsageReport.vue?vue&type=template&id=2c0cab15&scoped=true"
import script from "./DiscountUsageReport.vue?vue&type=script&lang=js"
export * from "./DiscountUsageReport.vue?vue&type=script&lang=js"
import style0 from "./DiscountUsageReport.vue?vue&type=style&index=0&id=2c0cab15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0cab15",
  null
  
)

export default component.exports